import React, { useState } from 'react';

function GoeAuth({ saveCredentials }) {
  const [name, setName] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [isController, setIsController] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    // Check if required fields are provided (only name and device_id are required)
    if (!name.trim() || !deviceId.trim()) {
      alert('Please enter both Name and Device ID');
      return;
    }

    setIsSaving(true);
    setSaveStatus('Saving...');

    // Build credentials object - only include api_key if provided
    const credentials = {
      name: name,
      device_id: deviceId,
      is_controller: isController
    };

    // Add API key only if provided
    if (apiKey.trim()) {
      credentials.api_key = apiKey;
    }

    const result = await saveCredentials('goe_credentials', credentials);

    setSaveStatus(result.message);

    if (result.success) {
      // Clear the form after successful save
      setTimeout(() => {
        setName('');
        setDeviceId('');
        setApiKey('');
        setIsController(false);
        setSaveStatus('');
      }, 2000);
    } else {
      setTimeout(() => setSaveStatus(''), 3000);
    }

    setIsSaving(false);
  };

  return (
    <div className="provider-card">
      <h3 className="provider-title">Go-e Charger</h3>
      <div className="input-group">
        <label htmlFor="goe_name" className="input-label">
          Name
        </label>
        <input
          id="goe_name"
          type="text"
          className="input-field"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter device name"
        />
      </div>
      <div className="input-group">
        <label htmlFor="goe_deviceId" className="input-label">
          Device ID
        </label>
        <input
          id="goe_deviceId"
          type="text"
          className="input-field"
          value={deviceId}
          onChange={(e) => setDeviceId(e.target.value)}
          placeholder="Enter your Go-e Device ID"
        />
      </div>
      <div className="input-group">
        <label htmlFor="goe_apiKey" className="input-label">
          API Key (Optional)
        </label>
        <input
          id="goe_apiKey"
          type="text"
          className="input-field"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="Enter your Go-e API key (optional)"
        />
      </div>
      <div className="input-group">
        <label htmlFor="goe_isController" className="input-label">
          <input
            id="goe_isController"
            type="checkbox"
            checked={isController}
            onChange={(e) => setIsController(e.target.checked)}
            style={{ marginRight: '8px', width: 'auto' }}
          />
          Controller
        </label>
      </div>
      <button
        onClick={handleSave}
        className="auth-button"
        disabled={isSaving}
      >
        {isSaving ? 'Saving...' : 'Save'}
      </button>
      {saveStatus && (
        <div className={`save-status ${saveStatus.includes('Error') ? 'error' : 'success'}`}>
          {saveStatus}
        </div>
      )}
    </div>
  );
}

export default GoeAuth;
